import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Agents from '../components/Frontend/AccountDetails/Agents/Agents';

export const agentsRoutes = (
  <>
    <Route path="account_details/agents" element={<MainLayout />}>
      <Route index element={<Agents />} />
    </Route>
  </>
);